import React from 'react';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import SEARCH from 'assets/img/search.svg';
import { CustomIcon, Input, Link } from '../../../../common';
import './style.scss';

export const ProjectsDropdown = ({ isDarkTheme }) => (
  <div className="navbar_dropdown_wrapper" onClick={e => e.stopPropagation()}>
    <Input
      iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
      style={{ margin: '26px 26px 13px 26px', width: 'calc(100% - 52px)' }}
      inputProps={{
        placeholder: 'Search Projects',
      }}
    />
    <Link to="/project/2">Project 1</Link>
    <Link to="/project/3">Project 2</Link>
    <Link to="/project/4">Project 3</Link>
    <Link to="/projects">
      <span style={{ cursor: 'pointer', userSelect: 'none', marginTop: '10px' }}>
        <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} height="10px" rotate="270" />View All Projects
      </span>
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ProjectsDropdown/index.js